import "@fontsource/open-sans/400.css"
import "@fontsource/nunito-sans/900.css"
import React from "react"
import Layout from "./components/layout"

export const wrapPageElement = ({ element }) => {
  return <Layout>{element}</Layout>
}
